jQuery(document).ready(function ($) {
    if ($('.template-collection-cubiste').length) {
      function getLastCouleurCeramiques() {
        const params = new URLSearchParams(window.location.search);
        let lastValue = null;
        for (const [key, value] of params.entries()) {
          if (key === 'filter.v.option.couleur céramique') {
            lastValue = value;
          }
        }
        return lastValue;
      }

      function initProductSlider($slider, targetIndex = 0) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          lazyLoad: 'ondemand',
          initialSlide: targetIndex
        });
      }

      function handleAllSliders() {
        var $sliders = $('.product-slider-custom');
        if ($sliders.length === 0) return;

        const colorName = (getLastCouleurCeramiques() || '').toLowerCase();

        $sliders.each(function () {
          const $slider = $(this);
          let targetIndex = 0;

          if (colorName) {
            $slider.find('.product-slide-custom').each(function () {
              const slideColor = ($(this).data('color') || '').toLowerCase();
              if (slideColor === colorName) {
                targetIndex = $(this).data('slick-index') || $(this).index();
                return false;
              }
            });
          }

          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
          }

          initProductSlider($slider, targetIndex);
        });
      }

      document.addEventListener('t4s:ajax_products_loaded', handleAllSliders);

      const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && node.querySelectorAll) {
                const $newSliders = $(node).find('.product-slider-custom');
                if ($newSliders.length) {
                  handleAllSliders();
                }
              }
            });
          }
        }
      });

      observer.observe(document.querySelector('.template-collection-cubiste'), {
        childList: true,
        subtree: true
      });

      handleAllSliders();

      $(document).on('click',
        '.layout-switch-button button',
        handleAllSliders
      );
    }
    else{
      // function initProductSlider() {
      //   $('.product-slider-custom').slick({
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     arrows: true,
      //     dots: false,
      //     infinite: true,
      //     lazyLoad: 'ondemand',
      //   });
      // }
      // initProductSlider();
      // $('.layout-switch-button button').click(function () {
      //   if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //     $('.product-slider-custom').slick('unslick');
      //   }
      //   initProductSlider();
      // });
      // $('.t4s-dropdown__content button').click(function () {
      //   var checkInterval = setInterval(function() {
      //     if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //       initProductSlider();
      //       clearInterval(checkInterval);
      //     } else {
      //       initProductSlider();
      //     }
      //   }, 200); 
      // });

      // $(document).on('click', '.t4s-pagination a', function (e) {
      //   setTimeout(function () {
      //     var checkInterval = setInterval(function() {
      //       if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //         clearInterval(checkInterval);
      //       } else {
      //         initProductSlider();
      //       }
      //     }, 500); 
      //   }, 500);
      // });
      // $(document).on('click', '.t4s-active-filters a', function (e) {
      //     setTimeout(function () {
      //       var checkInterval = setInterval(function() {
      //         if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //           clearInterval(checkInterval);
      //         } else {
      //           initProductSlider();
      //         }
      //       }, 500); 
      //     }, 500);
      // });

      // $(document).on('click', '#FacetFiltersForm a', function (e) {
      //   setTimeout(function () {
      //     var checkInterval = setInterval(function() {
      //       if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //         clearInterval(checkInterval);
      //       } else {
      //         initProductSlider();
      //       }
      //     }, 500); 
      //   }, 500);
      // });
      
      // document.addEventListener('t4s:ajax_products_loaded', function () {
      //   if ($('.product-slider-custom').hasClass('slick-initialized')) {
      //     $('.product-slider-custom').slick('unslick');
      //   }
      //   initProductSlider();
      // });

    
      // const sliderInterval = setInterval(function () {
      //   if ($('.product-slider-custom').length && !$('.product-slider-custom').hasClass('slick-initialized')) {
      //     initProductSlider();
      //     clearInterval(sliderInterval);
      //   }
      // }, 500);

      // ---------- Initialize the product slider ----------
      function initProductSlider() {
        const $slider = $('.product-slider-custom');

        // If no slider exists in DOM, do nothing
        if (!$slider.length) return;

        // Only initialize if not already initialized
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            lazyLoad: 'ondemand',
          });
        }
      }

      // ---------- Re-initialize slider (unslick first, then init) ----------
      function reinitProductSlider() {
        const $slider = $('.product-slider-custom');

        // If slider is already initialized, destroy it first
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        // Small delay to ensure DOM is fully rendered before re-init
        setTimeout(initProductSlider, 50);
      }

      // ---------- Initial slider setup when DOM is ready ----------
      $(document).ready(function() {
        initProductSlider();
      });

      // ---------- Event triggers for layout change, filters, pagination ----------
      $(document).on('click',
        '.layout-switch-button button, \
        .t4s-dropdown__content button, \
        .t4s-pagination a, \
        .t4s-active-filters a, \
        #FacetFiltersForm a',
        reinitProductSlider
      );

      // ---------- Trigger when AJAX products are loaded (T4S theme) ----------
      document.addEventListener('t4s:ajax_products_loaded', reinitProductSlider);

      // ---------- Backup: Observe DOM changes to initialize sliders added dynamically ----------
      const observer = new MutationObserver(() => {
        initProductSlider();
      });

      observer.observe(document.body, {
        childList: true, // Watch for added/removed child nodes
        subtree: true    // Watch the entire DOM tree
      });
    }
    // $('.wrap-product-reference').slick({
    //   slidesToShow: 4,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: false,
    //   infinite: false,
    //   lazyLoad: 'ondemand',
    //   responsive: [
    //     {
    //       breakpoint: 1400,
    //       settings: {
    //         slidesToShow: 3
    //       }
    //     },
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         slidesToShow: 2,
    //         arrows: false,
    //       }
    //     },
    //     {
    //       breakpoint: 520,
    //       settings: {
    //         slidesToShow: 1
    //       }
    //     }
    //   ]
    // });
})